import { ChannelsResponse } from "../../../models/channel"
import { AppDispatch } from "../../../store/store"
import { channelsApi } from "./controller"

export const updateChannelsCache = (
    dispatch: AppDispatch,
    projectId: string,
    updater: (draft: ChannelsResponse) => void
) => {
    dispatch(channelsApi.util.updateQueryData("getChannels", { projectId, declarations: {} }, updater))
}
